<template>
	<div class="default-input" :class="{'default-input--error' : errors.length, disabled : disabled, 'default-input--bg' : inputGray}">
		<span class="default-input__label" v-if="label">{{ label }}</span>
		<div class="default-input__wrapper">
			<div class="default-input__wrapper-el">
				<div class="default-input__input default-input__input--date">
					<v-date-picker class="date-calendar" color="green" :popover="{ visibility: 'click' }"  is24hr :masks="{input: 'DD.MM.YYYY'}" :mode="mode" :min-date='min' v-model="value[0]" @update:modelValue="test">
						<template v-slot="{ inputValue, inputEvents }">
							<input
								ref="inputField1"
								:value="inputValue"
								v-on="inputEvents"
								:disabled="disabled"
								:placeholder="placeholder"
								:inputmode="'numeric'"
							/>
						</template>
					</v-date-picker>
				</div>
			</div>
		</div>
		<ul v-if="errors.length" class="default-input__errors">
			<li v-for="(error,index) in errors" :key="index">{{ error.$message }}</li>
		</ul>
	</div>
</template>

<script>
import Inputmask from 'inputmask'


export default {
	name: "InputDate",
	emits: ["update:modelValue", "updateValue"],
	props: {
		modelValue: {
			type: Array,
			required: true,
			validator(value) {
				return value.length === 1
			},
			default: () => {}
		},
		disabled: {
			type: Boolean,
			default: false
		},
		placeholder: {
			type: String,
			default: "",
		},
		label: {
			type: String,
			default: ''
		},
		min: {
			type: [String, Number, Date],
			default: new Date(),
		},
		max: {
			type: [String, Number],
			default: null,
		},
		errors: {
			type: Array,
			default: () => []
		},
		inputGray: {
			type: Boolean,
			default: false
		},
		mode: {
			type: String,
			default: 'date'
		}
	},
	mounted() {
		Inputmask(this.mode === 'date' ? "99.99.9999"  : "99.99.9999 99:99", {
			placeholder: 'xx.xx.xxxx 00:00',
		}).mask(this.$refs.inputField1)
	},
	computed: {
		value: {
			get() {
				return this.modelValue
			},
			set(value) {
				this.$emit('update:modelValue', value)
			}
		},
	},
	methods: {
		test() {
			this.$emit('updateValue')
		}
	}
}
</script>


